import React from "react";
import './PriceList.scss'
import bag from '../../../images/pytel.svg';
import blob from '../../../images/blob.svg';
import pricelist from "./pricelist.json";
import { Sheet } from "./Sheet/Sheet";

import { Img } from "@randajan/jet-react/dom/img";


const PriceList = () => {
    return (
        <section className="PriceList slab">
            <div className="leftPane">
                <Img className='coffeeSpill' src={blob}/>
                <Img className='bag' src={bag} alt="" />
            </div>
            <section className='content'>
                <h2>
                    <strong>Menu</strong>
                    <small>Co dobrého jsme si pro vás připravili?</small>
                </h2>
                
                <h3 className='textHighlight'>Káva & teplé nápoje</h3>
                <Sheet list={pricelist}/>
            </section>
        </section>
    );
};

export default PriceList;
